import { render, staticRenderFns } from "./ProductMedia.vue?vue&type=template&id=5f57fc3e&scoped=true&"
import script from "./ProductMedia.vue?vue&type=script&lang=js&"
export * from "./ProductMedia.vue?vue&type=script&lang=js&"
import style0 from "./ProductMedia.vue?vue&type=style&index=0&id=5f57fc3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f57fc3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftCardPreview: require('/opt/atlassian/pipelines/agent/build/components/shop/conf/GiftCardPreview.vue').default,ProductMediaRender: require('/opt/atlassian/pipelines/agent/build/components/shop/conf/ProductMediaRender.vue').default,ShowMediaAsset: require('/opt/atlassian/pipelines/agent/build/components/common/ShowMediaAsset.vue').default,UiLazyImg: require('/opt/atlassian/pipelines/agent/build/components/Ui/UiLazyImg.vue').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCol,VDialog,VRow,VSlider})
